import axios from 'axios';
import { API } from '@/config/api';

const state = {
    packetItems: [],
};

const getters = {
    getPacketItems: (state) => state.packetItems,
};

const mutations = {
    setPacketItems: (state, packetItems) => {
        state.packetItems = packetItems;
    },
};

const actions = {
    async fetchPacketItems({ commit }) {
        try {
            const response = await axios.post(
                `${process.env.VUE_APP_API_BASE_URL}/api/frontend/getPacketItems`,
                {
                    "token": "test",
                    "limit": 50,
                    "page": 0
                }
            );

            if (response.data.status) {
                commit('setPacketItems', response.data.response.packetItems);
            } else {
                
            }
        } catch (error) {
            console.error('Error fetching packet items:', error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
